<!--
 * @Author: fanhengbin
 * @Date: 2021-07-18 15:31:59
 * @Descripttion: 上传图片
-->
<template>
  <div class="upload--attachment" :class="[type]">
    <template v-if="type === 'idCard' || type === 'certificate'">
      <div class="attachment-uploader" v-if="imageUrl || url">
        <div class="el-upload el-upload--text">
          <div class="attachment">
            <img :src="url || imageUrl" />
            <span class="attachment__item-actions">
              <span class="attachment__item-preview" @click="handlePicturePreview">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="attachment__item-delete" @click="handleRemove">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </div>
      </div>
      <el-upload
        v-else
        class="attachment-uploader"
        action="/api/file/upload"
        accept="image/jpeg, image/jpg, image/png"
        :show-file-list="false"
        :on-success="handleAttachmentSuccess"
        :before-upload="beforeAttachmentUpload"
      >
        <i class="el-icon-plus attachment-uploader-icon" />
      </el-upload>
    </template>
    <!-- <template v-if="type === 'certificate'">
      <el-upload
        class="certificate--uploader"
        action="/api/file/upload"
        accept="image/jpeg, image/jpg, image/png"
        :show-file-list="false"
        :on-success="handleAttachmentSuccess"
        :before-upload="beforeAttachmentUpload"
      >
        <div class="upload--certificate">
          <div class="upload--certificate--icon">
            <img src="@/render/assets/images/auth/icon-word.png" />
          </div>
          <div class="upload--certificate--text">{{ uploadedFile ? uploadedFile.name : '上传' }}</div>
        </div>
      </el-upload>
    </template> -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'idCard',
    },
    value: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
    },
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      uploadedFile: null
    }
  },
  computed: {
    imageUrl() {
      return this.uploadedFile ? this.uploadedFile.response.data : ''
    },
    wordUrl() {
      return this.uploadedFile ? this.uploadedFile.response.data : ''
    }
  },
  methods: {
    handlePicturePreview() {
      this.dialogImageUrl = this.imageUrl
      this.dialogVisible = true
    },
    handleRemove() {
      this.$emit('input', '')
      this.uploadedFile = null
    },
    handleAttachmentSuccess(res, file) {
      this.$emit('input', res.data)
      this.uploadedFile = file
    },
    beforeAttachmentUpload(file) {
      let successFlag = true
      const isLt5M = file.size / 1024 / 1024 < 5
      if (this.type === 'idCard' || this.type === 'certificate') {
        if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
          successFlag = false
          this.$message.error('上传类型不符合!')
        } else if (!isLt5M) {
          successFlag = false
          if (this.type === 'idCard') {
            this.$message.error('上传附件图片大小不能超过 5MB!')
          } else {
            this.$message.error('上传考级证书大小不能超过 5MB!')
          }
        }
      }
      return successFlag
    },
  },
}
</script>

<style lang="scss" scoped>
.attachment-uploader ::v-deep {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
  .attachment-uploader-icon {
    font-size: 28px;
    color: #C5C5C5;
    width: val(120);
    height: val(90);
    line-height: val(90);
    text-align: center;
  }
  .attachment {
    position: relative;
    width: val(120);
    height: val(90);
    display: block;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    &:hover {
      .attachment__item-actions {
        opacity: 1;
        span {
          display: inline-block;
        }
      }
    }
    &__item-actions {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 50;
      left: 0;
      top: 0;
      cursor: default;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      span {
        display: none;
        font-size: 14px;
        margin-right: 6px;
        cursor: pointer;
        &:last-of-type {
          margin: 0;
        }
      }
    }
  }
}
.upload--attachment.certificate .attachment-uploader ::v-deep {
  .attachment-uploader-icon {
    width: val(160);
    height: val(120);
    line-height: val(120);
  }
  .attachment {
    width: val(160);
    height: val(120);
  }
}
// ::v-deep.certificate--uploader {
//   .upload--certificate {
//     width: val(120);
//     height: val(90);
//     padding-top: val(12);
//     background: rgba(#eff2f7, 0.4);
//     border: 1px solid rgba(#317bff, 0.4);
//     border-radius: 6px;
//     text-align: center;
//     box-sizing: border-box;
//     &--icon {
//       display: inline-block;
//       width: val(32);
//     }
//     &--text {
//       text-align: center;
//       width: 100%;
//       font-size: val(14);
//       color: #acc9ff;
//       line-height: val(14);
//       margin-top: val(8);
//     }
//   }
// }
</style>
